<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogv" fullscreen hide-overlay transition="dialog-bottom-transition">      
      <v-card>        
        <v-card-text class="pa-0">
          <dialog-eks :kompetisi_id="kompetisi_id" :tps_id="tps_id" v-on:close="closeDialog($event)" v-if="mode === 1"></dialog-eks>
          <dialog-leg :kompetisi_id="kompetisi_id" :tps_id="tps_id" v-on:close="closeDialog($event)" v-if="mode === 2"></dialog-leg>
          <dialog-dpd :kompetisi_id="kompetisi_id" :tps_id="tps_id" v-on:close="closeDialog($event)" v-if="mode === 3"></dialog-dpd>
          
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import DialogEks from './dialog-eks';
import DialogLeg from './dialog-leg';
import DialogDpd from './dialog-dpd';

export default {
  name : 'form-dialog',  
  components: {
    DialogEks,
    DialogLeg,
    DialogDpd
  },
  props:{    
    cekup  : Object,
    dialog : {
      type: Boolean,
      default: false,
    },
  }, 
  data () {
    return {
      dialogv: false,
      mode : null,
      kompetisi_id:null,
      tps_id:null
      //chat: null,
      //selectedTab: null,
    };
  }, 
  asyncComputed:{
    init(){
      if(!this.dialogv){
        this.dialogv = this.dialog;              
        if(this.dialogv){                    
          this.mode = this.cekup.mode;
          this.kompetisi_id = String(this.cekup.kompetisi_id);
          this.tps_id = String(this.cekup.tps_id);
        }        
      } else {
        this.dialogv = this.dialog;
      }
      return;
    }
  },
  /*computed: {
    showFormEks() {
      return this.mode == 1;
    },
    showFormLeg() {
      return this.mode == 2;
    },
    showFormDpd() {
      return this.mode == 3;
    },            
  },*/
  methods: {          
    closeDialog(e){      
      this.dialogv = false;
      this.$emit('closeDialog',{dialog : false, cekup:{}, reload:e});
    }
  } 
};
</script>

